export default "__VITE_ASSET__B_j7gQdH__ 640w, __VITE_ASSET__CUSJin8g__ 1024w, __VITE_ASSET__DMq0ORar__ 1280w";